<div *ngIf="user" class="navbar-user" nz-row>
    <app-icon nz-col name="icon-profile-business-man" size="lg"></app-icon>
    <div nz-col class="navbar-user__user-data">
        <div class="navbar-user__username">{{ user?.firstName }} {{ user?.lastName }}</div>
        <div class="navbar-user__email">{{ user?.email }}</div>
    </div>
</div>
